import { render, staticRenderFns } from "./BoxNotification.vue?vue&type=template&id=1970511e&lang=pug"
import script from "./BoxNotification.vue?vue&type=script&lang=js"
export * from "./BoxNotification.vue?vue&type=script&lang=js"
import style0 from "./BoxNotification.vue?vue&type=style&index=0&id=1970511e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports